import api from "../axiosInstance";

export const createAIFeedingAPI = async (data) => {
    return await api.post("/ai-feeding", data);
};

export const getAIFeedingsAPI = async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    return await api.get(`/ai-feeding?${params}`);
};

export const updateAIFeedingAPI = async (id, data) => {
    return await api.put(`/ai-feeding/${id}`, data);
};

export const deleteAIFeedingAPI = async (id) => {
    return await api.delete(`/ai-feeding/${id}`);
};
